import { NgModule } from '@angular/core';
import { BuFooterComponent } from './bu-footer/bu-footer.component';

@NgModule({
  imports: [],
  declarations: [
    BuFooterComponent
  ],
  exports: [
    BuFooterComponent
  ]
})
export class BuFooterModule { }
